var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contacts-link"},[_c('span',{staticClass:"type"},[_vm._v("\n    "+_vm._s(_vm.contact.displayType)+"\n  ")]),_c('a',{attrs:{"href":_vm.contact.url}},[_vm._v("\n    "+_vm._s(_vm.contact.displayName)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }